/**
 * Given name + optional nickname for Book Notes (#980).
 * Display is `Charlotte (Charlie)`. No nickname dictionary.
 */

export function parsePersonLabel(label) {
  const raw = (label || '').trim();
  const match = raw.match(/^(.*?)\s*\(([^)]+)\)\s*$/);
  if (match && match[1].trim() && match[2].trim()) {
    return { name: match[1].trim(), nickname: match[2].trim() };
  }
  return { name: raw, nickname: '' };
}

export function formatPersonLabel(name, nickname) {
  const parsed = parsePersonLabel(name);
  const primary = parsed.name;
  const nick = (nickname || parsed.nickname || '').trim();
  if (!primary) return nick;
  if (!nick || nick.toLowerCase() === primary.toLowerCase()) return primary;
  return `${primary} (${nick})`;
}

export function uniqueNameList(values) {
  const out = [];
  const seen = new Set();
  for (const value of values || []) {
    const text = (value || '').trim();
    if (!text) continue;
    const key = text.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(text);
  }
  return out;
}

/**
 * Session-gather needles: primary + nickname + prior chat names.
 * A typed surname still finds given-name talk (first token). The surname
 * itself is not added — do not invent biography from Hale-only hits.
 */
export function personFocusNames({ name = '', nickname = '', alsoKnownAs = [] } = {}) {
  const parsed = parsePersonLabel(name);
  const primary = parsed.name;
  const nick = (nickname || parsed.nickname || '').trim();
  const extras = uniqueNameList([primary, nick, ...(alsoKnownAs || [])]);
  if (primary && primary.includes(' ')) {
    return uniqueNameList([...extras, primary.split(/\s+/)[0]]);
  }
  return extras;
}

export function cardMatchesPerson(entry, wanted) {
  const needle = (wanted || '').trim().toLowerCase();
  if (!needle) return false;
  const names = personFocusNames({
    name: entry?.instance_name || entry?.name || '',
    nickname: entry?.nickname,
    alsoKnownAs: entry?.also_known_as || entry?.alsoKnownAs,
  });
  return names.some((n) => n.toLowerCase() === needle);
}
